import { V_URL_API } from "../../../../utils/config";

/**
 * Servicio para obtener todos los cursos pero empaginados.
 *
 * @param {number} page - La página actual a obtener.
 * @param {number} page_size - Cantidad de cursos por página.
 * @returns {Promise<Response>} - Respuesta de la API con toda la información paginada.
 * @throws {Error} - Lanza un error si la petición falla.
 */
export async function getCursosEmpaginados(page, page_size, categorias_id) {
  const requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  page_size = 10
  // Construcción dinámica de la URL
  let url = `${V_URL_API}/api/cursos?page=${page}&page_size=${page_size}`;

  if (categorias_id.length > 0) {
    url += categorias_id.map(id => `&categoria_ids=${id}`).join(''); 
    // 👆 Esto genera: &categoria_ids=998&categoria_ids=1006
  }

  return await fetch(url, requestOptions);
}
